import { request } from './api';

const automationBuilderService = {
  listWorkflows() {
    return request('/api/automation/builder/workflows', { method: 'GET' });
  },
  createWorkflow({ name, graph }) {
    return request('/api/automation/builder/workflows', { method: 'POST', body: { name, graph } });
  },
  getWorkflow(id, options = {}) {
    return request(`/api/automation/builder/workflows/${id}`, { method: 'GET', ...(options || {}) });
  },
  saveDraft(id, { name, graph }, options = {}) {
    return request(`/api/automation/builder/workflows/${id}/draft`, { method: 'PUT', body: { name, graph }, ...(options || {}) });
  },
  validate(id, { graph }, options = {}) {
    return request(`/api/automation/builder/workflows/${id}/validate`, { method: 'POST', body: { graph }, ...(options || {}) });
  },
  publish(id, { backendBaseUrl } = {}) {
    return request(`/api/automation/builder/workflows/${id}/publish`, { method: 'POST', body: { backendBaseUrl } });
  },
  rollback(id, { version }) {
    return request(`/api/automation/builder/workflows/${id}/rollback`, { method: 'POST', body: { version } });
  },
  test(id, { payload }) {
    return request(`/api/automation/builder/workflows/${id}/test`, { method: 'POST', body: { payload } });
  },
  async deleteWorkflow(id) {
    try {
      return await request(`/api/automation/builder/workflows/${id}`, { method: 'DELETE' });
    } catch (err) {
      const message = String(err?.message || '');
      const status = Number(err?.status || 0);
      const payloadMessage = String(err?.payload?.message || err?.payload?.error || '');
      const looksLikeRouteMissing = /rota n[aã]o encontrada/i.test(message) || /rota n[aã]o encontrada/i.test(payloadMessage);
      if (status === 404 && looksLikeRouteMissing) {
        return request(`/api/automation/builder/workflows/${id}/delete`, { method: 'POST', body: {} });
      }
      throw err;
    }
  }
};

export default automationBuilderService;
